export default __webpack_public_path__ + "static/media/click.84687dfd.mp3";